import { Impressionable } from '@fiverr-private/futile/lib/element/Impressionable';
import { createBaseEventParams } from '../events/base';

class ImpressionsFactory {

    constructor({requestContext, general, packagesCount}) {
        this.baseParams = createBaseEventParams({requestContext, general, packagesCount});
    }

    create(eventName, params = {}) {
        const options = this.createOptions(eventName, params);

        return new Impressionable(options);
    }

    createOptions(eventName, params) {
        return { ...this.baseParams, ...params, eventName };
    }

}

export default ImpressionsFactory;
